import Vue from "vue";
Vue.directive("restrict", {
  bind: function(el, binding) {
    el.addEventListener("keypress", function(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      // if (
      //   ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 110) || // 46 for delete & 110 for Decimal
      //   event.target.value.toString().length >= binding.value
      // ) {
      //   event.preventDefault();
      // }
      // if (isNaN(String.fromCharCode(keyCode) && keyCode!==110)) {
      //   event.preventDefault();
      // }
      if(event.target.value ==0){
        event.target.value=""
      }
      if (event.keyCode == 32) {
        event.preventDefault();
      }
      if (isNaN(String.fromCharCode(event.keyCode)) && keyCode !== 46) {
        event.preventDefault();
      }
      if (
        event.target.value != undefined &&
        event.target.value.toString().length >= binding.value
      ) {
        event.preventDefault();
      }
    });
  }
});

Vue.directive("temperature", {
  bind: function(el, binding = 10) {
    el.addEventListener("keypress", function(event) {

      let keyCode = event.keyCode ? event.keyCode : event.which;

      if(event.target.value ==0){
        event.target.value=""
      }
      if (event.keyCode == 32) {
        event.preventDefault();
      }
      if (isNaN(String.fromCharCode(event.keyCode)) && keyCode !== 46) {
        event.preventDefault();
      }
      let key = event.key;
      let string = event.target.value + key;
      let beforeDecimle = string.split(".")[0];
      let afterDecimle = string.split(".")[1];

      if(beforeDecimle && beforeDecimle.toString().length > 3){
        event.preventDefault();
      }
      if(afterDecimle && afterDecimle.toString().length > 2){
        event.preventDefault();
      }

    });
  }
});

Vue.directive("weight", {
  bind: function(el, binding = 10) {
    el.addEventListener("keypress", function(event) {

      let keyCode = event.keyCode ? event.keyCode : event.which;

      if(event.target.value ==0){
        event.target.value=""
      }
      if (event.keyCode == 32) {
        event.preventDefault();
      }
      if (isNaN(String.fromCharCode(event.keyCode)) && keyCode !== 46) {
        event.preventDefault();
      }
      let key = event.key;
      let string = event.target.value + key;
      let beforeDecimle = string.split(".")[0];
      let afterDecimle = string.split(".")[1];

      if(beforeDecimle && beforeDecimle.toString().length > 2){
        event.preventDefault();
      }
      if(afterDecimle && afterDecimle.toString().length > 2){
        event.preventDefault();
      }

    });
  }
});

